/* ==========================================================
   Embroidery Monkey – Wishlist
   Saves favourite designs in the shopper's browser.
   - Heart buttons:   any element with data-em-wishlist-handle="product-handle"
   - Header count:    any element with data-em-wishlist-count
   - Wishlist page:   a page containing <div id="em-wishlist-page"></div>
   ========================================================== */
(function () {
  if (window.EMWishlist) return;

  var STORAGE_KEY = 'em_wishlist_v1';
  var PRICE_KEY = 'em_wishlist_prices_v1'; // price (in cents) at the moment each design was saved
  var BRAND = '#c9550d';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- storage ---------- */
  function read() {
    try {
      var list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage full or blocked – ignore */
    }
  }

  function readPrices() {
    try {
      var map = JSON.parse(localStorage.getItem(PRICE_KEY) || '{}');
      return map && typeof map === 'object' ? map : {};
    } catch (e) {
      return {};
    }
  }

  function writePrices(map) {
    try {
      localStorage.setItem(PRICE_KEY, JSON.stringify(map));
    } catch (e) {}
  }

  function rememberPrice(handle, cents) {
    if (!handle || isNaN(cents)) return;
    var map = readPrices();
    map[handle] = cents;
    writePrices(map);
  }

  function forgetPrice(handle) {
    var map = readPrices();
    if (handle in map) {
      delete map[handle];
      writePrices(map);
    }
  }

  // Use the price on the button if it has one, otherwise look it up
  function recordPriceFor(handle, btn) {
    var fromBtn = btn && btn.getAttribute('data-em-price');
    if (fromBtn !== null && fromBtn !== '' && !isNaN(parseInt(fromBtn, 10))) {
      rememberPrice(handle, parseInt(fromBtn, 10));
      return;
    }
    fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p && has(handle)) rememberPrice(handle, p.price); })
      .catch(function () {});
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function add(handle) {
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle); // newest first
    write(list);
  }

  function remove(handle) {
    write(read().filter(function (h) { return h !== handle; }));
    forgetPrice(handle);
  }

  function toggle(handle) {
    if (has(handle)) {
      remove(handle);
      return false;
    }
    add(handle);
    return true;
  }

  /* ---------- styles ---------- */
  function injectStyles() {
    if (document.getElementById('em-wishlist-styles')) return;
    var css = [
      '.em-wishlist-btn{display:inline-flex;align-items:center;gap:.8rem;cursor:pointer;font:inherit;line-height:1;background:#fff;color:#1a1a1a;border:2px solid ' + BRAND + ';border-radius:999px;padding:1rem 1.8rem;font-size:1.4rem;font-weight:600;transition:background-color .15s ease,color .15s ease,transform .1s ease;}',
      '.em-wishlist-btn:hover{background:#fbf3ec;}',
      '.em-wishlist-btn:active{transform:scale(.97);}',
      '.em-wishlist-btn svg{width:2rem;height:2rem;flex-shrink:0;fill:none;stroke:' + BRAND + ';stroke-width:2;transition:fill .15s ease;}',
      '.em-wishlist-btn.is-active svg{fill:' + BRAND + ';}',
      '.em-wishlist-btn.is-active{background:#fbf3ec;}',
      /* heart on product cards */
      '.em-wishlist-btn--card{position:absolute;top:.8rem;right:.8rem;z-index:4;width:3.8rem;height:3.8rem;padding:0;justify-content:center;border:1px solid #eadfd5;box-shadow:0 2px 6px rgba(0,0,0,.08);}',
      '.em-wishlist-btn--card svg{width:1.9rem;height:1.9rem;}',
      /* header count bubble */
      '.em-wishlist-count{position:absolute;bottom:.8rem;left:2.2rem;min-width:1.7rem;height:1.7rem;padding:0 .3rem;border-radius:999px;background:' + BRAND + ';color:#fff;font-size:.9rem;font-weight:700;line-height:1.7rem;text-align:center;}',
      '.em-wishlist-count[hidden]{display:none;}',
      '.header__icon--wishlist{position:relative;}',
      '.header__icon--wishlist svg{width:2.6rem !important;height:2.6rem !important;}',
      '.header__icon--wishlist.has-items svg{fill:#e0245e !important;stroke:#e0245e !important;}',
      /* wishlist page: matches the store's product grid (px + id selectors so page styles can't enlarge it) */
      '#em-wishlist-page{width:min(1200px,calc(100vw - 40px));margin:20px 0 50px 50%;transform:translateX(-50%);font-size:14px !important;line-height:1.35 !important;}',
      '#em-wishlist-page *{line-height:1.35 !important;}',
      '#em-wishlist-page .em-wl-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:28px 20px;}',
      '@media (min-width:750px){#em-wishlist-page .em-wl-grid{grid-template-columns:repeat(3,minmax(0,1fr));}}',
      '@media (min-width:990px){#em-wishlist-page .em-wl-grid{grid-template-columns:repeat(4,minmax(0,1fr));}}',
      '#em-wishlist-page .em-wl-card{position:relative;display:flex;flex-direction:column;background:#fff;min-width:0;}',
      '#em-wishlist-page .em-wl-card__img{position:relative;display:block;width:100%;height:0;padding:0 0 100% 0 !important;overflow:hidden;text-decoration:none !important;}',
      '#em-wishlist-page .em-wl-card__img img{position:absolute !important;top:16px;left:16px;width:calc(100% - 32px) !important;height:calc(100% - 32px) !important;max-width:none !important;object-fit:contain;display:block;margin:0 !important;border:0 !important;box-shadow:none !important;border-radius:0 !important;}',
      '#em-wishlist-page .em-wl-card__sale{position:absolute;top:10px;right:10px;z-index:2;background:#e6ff00;color:#1a1a1a;border:1px solid #d4ea00;border-radius:999px;padding:3px 10px;font-size:12px !important;font-weight:400;letter-spacing:.04em;}',
      '#em-wishlist-page .em-wishlist-btn--card{top:10px;left:10px;right:auto;width:34px;height:34px;}',
      '#em-wishlist-page .em-wishlist-btn--card svg{width:17px;height:17px;}',
      '#em-wishlist-page .em-wl-card__body{display:flex;flex-direction:column;gap:8px;padding:14px 20px 0;flex:1;}',
      '#em-wishlist-page .em-wl-card__title{font-size:14px !important;font-weight:700 !important;line-height:1.5 !important;min-height:4.5em;color:#1a1a1a !important;text-decoration:none !important;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;margin:0 !important;}',
      '#em-wishlist-page .em-wl-card__title:hover{text-decoration:underline !important;}',
      '#em-wishlist-page .em-wl-card__price{font-size:16px !important;font-weight:700;letter-spacing:.06em;color:#1a1a1a;margin:0 !important;display:flex;flex-wrap:wrap;gap:0 18px;}',
      '#em-wishlist-page .em-wl-card__price s,#em-wishlist-page .em-wl-card__price span{font-size:16px !important;line-height:1.4 !important;}',
      '#em-wishlist-page .em-wl-card__price s,#em-wishlist-page .em-wl-card__price span{white-space:nowrap;}',
      '#em-wishlist-page .em-wl-card__price s{color:#e00000;font-weight:700;}',
      '#em-wishlist-page .em-wl-card__add{display:block;width:100%;max-width:250px;margin:auto 0 0 !important;cursor:pointer;border:none;border-radius:0;background:#f02c4c;color:#fff !important;font-family:inherit;font-size:14px !important;font-weight:800;letter-spacing:.05em;text-transform:uppercase;white-space:nowrap;padding:17px 10px;text-align:center;text-decoration:none !important;box-sizing:border-box;}',
      '#em-wishlist-page .em-wl-card__add:hover{background:#d41f3d;}',
      '#em-wishlist-page .em-wl-card__price{margin-bottom:14px !important;}',
      '#em-wishlist-page .em-wl-card__add[disabled]{opacity:.6;cursor:default;}',
      '#em-wishlist-page .em-wl-empty{text-align:center;padding:40px 10px;font-size:16px !important;}',
      '#em-wishlist-page .em-wl-empty a{display:inline-block;margin-top:16px;background:#f02c4c;color:#fff !important;padding:14px 28px;font-weight:800;text-transform:uppercase;letter-spacing:.05em;text-decoration:none !important;}',
      '#em-wishlist-page .em-wl-note{position:relative;max-width:640px;margin:4px 0 28px 4px;padding:16px 20px 16px 22px;background:#fff59d;color:#1a1a1a;font-size:15px !important;box-shadow:2px 4px 10px rgba(0,0,0,.12);transform:rotate(-0.6deg);border-radius:2px;}',
      '#em-wishlist-page .em-wl-note:before{content:"";position:absolute;top:-9px;left:50%;width:90px;height:20px;margin-left:-45px;background:rgba(255,255,255,.55);box-shadow:0 1px 2px rgba(0,0,0,.08);transform:rotate(-2deg);}',
      '#em-wishlist-page .em-wl-note strong{font-weight:800;}',
      '#em-wishlist-page .em-wl-card__change{font-size:13px !important;font-weight:600;margin:-8px 0 12px !important;}',
      '#em-wishlist-page .em-wl-card__change--up{color:#8a5a00;}',
      '#em-wishlist-page .em-wl-card__change--down{color:#1c7c3a;}',
      '#em-wishlist-page .em-wl-toolbar{display:flex;justify-content:space-between;align-items:center;margin-bottom:24px;padding-bottom:12px;border-bottom:1px solid #eee;font-size:15px !important;}',
      '#em-wishlist-page .em-wl-toolbar button{background:none;border:none;color:#1a1a1a;font-family:inherit;font-size:14px !important;font-weight:600;cursor:pointer;text-decoration:underline;}'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'em-wishlist-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ---------- buttons & count ---------- */
  function refreshButtons(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll ? scope.querySelectorAll('[data-em-wishlist-handle]') : [];
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var active = has(btn.getAttribute('data-em-wishlist-handle'));
      // Only touch the page when something really changed (keeps other apps calm)
      if (btn.classList.contains('is-active') !== active) btn.classList.toggle('is-active', active);
      var pressed = active ? 'true' : 'false';
      if (btn.getAttribute('aria-pressed') !== pressed) btn.setAttribute('aria-pressed', pressed);
      var aria = active ? 'Remove from wishlist' : 'Add to wishlist';
      if (btn.getAttribute('aria-label') !== aria) btn.setAttribute('aria-label', aria);
      var label = btn.querySelector('.em-wishlist-btn__label');
      var text = active ? 'Saved to Wishlist' : 'Add to Wishlist';
      if (label && label.textContent !== text) label.textContent = text;
    }
  }

  function refreshCount() {
    var count = read().length;
    var els = document.querySelectorAll('[data-em-wishlist-count]');
    for (var i = 0; i < els.length; i++) {
      var countText = count > 99 ? '99+' : String(count);
      if (els[i].textContent !== countText) els[i].textContent = countText;
      if (count > 0) els[i].removeAttribute('hidden');
      else els[i].setAttribute('hidden', '');
    }
    // header heart turns solid red when something is saved
    var links = document.querySelectorAll('[data-em-wishlist-link]');
    for (var j = 0; j < links.length; j++) {
      if (links[j].classList.contains('has-items') !== count > 0) links[j].classList.toggle('has-items', count > 0);
      var linkLabel = count > 0 ? 'Wishlist (' + count + ' saved)' : 'Wishlist';
      if (links[j].getAttribute('aria-label') !== linkLabel) links[j].setAttribute('aria-label', linkLabel);
    }
  }

  function refreshAll() {
    refreshButtons();
    refreshCount();
  }

  /* ---------- money ---------- */
  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }).format(cents / 100) + ' ' + currency;
    } catch (e) {
      return '$' + (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---------- wishlist page ---------- */
  function renderPage() {
    var container = document.getElementById('em-wishlist-page');
    if (!container) return;

    var handles = read();

    if (!handles.length) {
      container.innerHTML =
        '<div class="em-wl-empty"><p>Your wishlist is empty.</p>' +
        '<p>Tap the heart on any design to save it here.</p>' +
        '<a href="' + ROOT + 'collections/all">Browse designs</a></div>';
      return;
    }

    container.innerHTML = '<p class="em-wl-empty">Loading your wishlist…</p>';

    Promise.all(
      handles.map(function (handle) {
        return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      // clean out designs that no longer exist
      var stillThere = [];
      products.forEach(function (p, i) { if (p) stillThere.push(handles[i]); });
      if (stillThere.length !== handles.length) {
        write(stillThere);
        refreshCount();
      }

      var items = products.filter(Boolean);
      if (!items.length) {
        write([]);
        refreshCount();
        renderPage();
        return;
      }

      var savedPrices = readPrices();
      var anyWentUp = items.some(function (p) {
        var was = savedPrices[p.handle];
        return typeof was === 'number' && p.price > was;
      });

      var note = anyWentUp
        ? '<strong>Heads up!</strong> Some prices have changed since you saved them. Flash sale prices end when the sale does, so the price shown here is always today\'s price.'
        : '<strong>\ud83d\udca1 Good to know:</strong> Prices shown are today\'s prices. Flash sale designs go back to their regular price when the sale ends, so grab your favorites while they\'re on sale!';

      var html =
        '<div class="em-wl-note" role="note">' + note + '</div>' +
        '<div class="em-wl-toolbar"><span>' + items.length + (items.length === 1 ? ' design' : ' designs') + ' saved</span>' +
        '<button type="button" data-em-wl-clear>Clear wishlist</button></div>' +
        '<div class="em-wl-grid">';

      items.forEach(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=400';

        var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
        var price = money(p.price);
        var compare = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s>' : '';
        var was = savedPrices[p.handle];
        var change = '';
        if (typeof was === 'number' && p.price > was) {
          change = '<div class="em-wl-card__change em-wl-card__change--up">Was ' + money(was) + ' when you saved it</div>';
        } else if (typeof was === 'number' && p.price < was) {
          change = '<div class="em-wl-card__change em-wl-card__change--down">Price dropped since you saved it! \ud83c\udf89</div>';
        }

        html +=
          '<div class="em-wl-card">' +
            '<button type="button" class="em-wishlist-btn em-wishlist-btn--card is-active" data-em-wishlist-handle="' + escapeHtml(p.handle) + '" data-em-wl-remove aria-pressed="true" aria-label="Remove from wishlist">' +
              '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10.1A4.4 4.4 0 0 1 12 7.6a4.4 4.4 0 0 1 7.5 2.8c0 5.5-7.5 10.1-7.5 10.1z"/></svg>' +
            '</button>' +
            '<a class="em-wl-card__img" href="' + escapeHtml(p.url) + '">' +
              (compare ? '<span class="em-wl-card__sale">Sale</span>' : '') +
              (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="em-wl-card__body">' +
              '<a class="em-wl-card__title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
              '<div class="em-wl-card__price">' + compare + '<span>' + price + '</span></div>' +
              change +
              (variant && variant.available
                ? '<button type="button" class="em-wl-card__add" data-em-wl-add="' + variant.id + '">Add to cart</button>'
                : '<button type="button" class="em-wl-card__add" disabled>Sold out</button>') +
            '</div>' +
          '</div>';
      });

      html += '</div>';
      container.innerHTML = html;
    });
  }

  function updateCartIcon(sections) {
    // Refresh the cart icon + count bubble in the header (Dawn's cart-icon-bubble section)
    var html = sections && sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (!html || !bubble) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.shopify-section') || doc.body;
    if (fresh) bubble.innerHTML = fresh.innerHTML;
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-em-wl-add');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        // Added – refresh the page so the cart icon shows the new count
        btn.textContent = 'Added ✓';
        setTimeout(function () { window.location.reload(); }, 400);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Try again';
      });
  }

  /* ---------- events ---------- */
  document.addEventListener(
    'click',
    function (event) {
      var heart = event.target.closest('[data-em-wishlist-handle]');
      if (heart) {
        event.preventDefault();
        event.stopPropagation();
        var handleClicked = heart.getAttribute('data-em-wishlist-handle');
        var nowSaved = toggle(handleClicked);
        if (nowSaved) recordPriceFor(handleClicked, heart);
        refreshAll();
        if (heart.hasAttribute('data-em-wl-remove')) renderPage();
        return;
      }

      var addBtn = event.target.closest('[data-em-wl-add]');
      if (addBtn) {
        event.preventDefault();
        addToCart(addBtn);
        return;
      }

      if (event.target.closest('[data-em-wl-clear]')) {
        event.preventDefault();
        if (window.confirm('Remove all designs from your wishlist?')) {
          write([]);
          writePrices({});
          refreshAll();
          renderPage();
        }
      }
    },
    true
  );

  // keep several open tabs in sync
  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      refreshAll();
      renderPage();
    }
  });

  // hearts added later (filters, "load more", quick view) get the right state
  // Only react when NEW heart buttons are added to the page (e.g. filters, "load more").
  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var added = mutations[m].addedNodes;
      for (var n = 0; n < added.length; n++) {
        var node = added[n];
        if (node.nodeType !== 1) continue;
        if (
          (node.hasAttribute && node.hasAttribute('data-em-wishlist-handle')) ||
          (node.querySelector && node.querySelector('[data-em-wishlist-handle]'))
        ) {
          refreshButtons(node.parentNode || document);
        }
      }
    }
  });

  function init() {
    injectStyles();
    refreshAll();
    renderPage();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.EMWishlist = { read: read, has: has, add: add, remove: remove, toggle: toggle, refresh: refreshAll };
})();